/**
 * Utility functions for working with Angular Material dialogs
 */

/**
 * Safely checks if a dialog result has a specific action
 * @param result The result from dialog.afterClosed().subscribe()
 * @param actionValue The action value to check for (defaults to true)
 * @returns boolean indicating if the action matches
 */
export function hasDialogAction(result: any, actionValue: any = true): boolean {
  return result?.action === actionValue;
} 